/*------------------------------------*\
    FORM REVIEW
\*------------------------------------*/
import Bugsnag from '@bugsnag/js'
import site from '../../site/_data/site';
var global = require('../../site/_data/site');

if(global.bugsnagApiKey) {
    Bugsnag.start(global.bugsnagApiKey);
}

class FormReview {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        self.calculateProgress();
        self.populateTable();
        self.populateHiddenFields();
        self.checkRequiredFields();
        self.submit();
    }

    calculateProgress() {
        let self = this;
        let fields = self.getLocalStorage();
    }

    checkRequiredFields() {
        // Check if user's personal details are complete
        if (!localStorage.getItem('your-details-section')) {
            document.getElementById("required-fields").classList.toggle('d-none');
            document.getElementById("feedback-ready").classList.toggle('d-none');
        }
    }

    populateTable() {
        let self = this;
        let table = self.elem.querySelector('[data-fields]');

        // Get all item from local storage
        let fields = self.getLocalStorage();

        fields.sort(function(a, b){
            if(a.name < b.name) {
                return -1;
            }

            if(a.name > b.name) {
                return 1;
            }

            return 0;
        });

        // Loop through the items
        fields.forEach(field => {
            // Create the markup for a table row
            let markup = `
                <tr>
                    <th scope="row">${field.label}</th>
                    <td>${self.nl2br(field.value)}</td>
                </tr>
            `;

            // Insert the table row inside the table body
            table.insertAdjacentHTML('beforeend', markup);
        });
    }

    populateHiddenFields() {
        let self = this;

        // Get all item from local storage
        let fields = self.getLocalStorage();

        fields.sort(function(a, b){
            if(a.name < b.name) {
                return -1;
            }

            if(a.name > b.name) {
                return 1;
            }

            return 0;
        });

        // Loop through the items
        fields.forEach(field => {
            // Create the markup for a hidden input
            let markup = document.createElement('input');
            markup.setAttribute('type', 'hidden');
            markup.setAttribute('name', field.name);
            markup.setAttribute('value', field.value);
            self.elem.append(markup);
        });
    }

    // Get all items from local storage and convert to array
    // containing an object for each item
    getLocalStorage() {
        let self = this;

        let archive = [],
            keys = Object.keys(localStorage),
            i = 0, key;

        for (; key = keys[i]; i++) {
            // Ignore bugsnag, section & recaptcha keys
            if(key !== 'cookiefirst-id' && key !== 'bugsnag-anonymous-id' && key !== '_grecaptcha' && !key.includes('section') && !key.includes('tour') && !key.includes('mrkrui')) {
                let data = JSON.parse(localStorage.getItem(key));
                console.log(key)

                archive.push({
                    'name': key,
                    'label': data.label,
                    'value': data.value
                });
            }
        }

        return archive;
    }

    submit() {
        let self = this;

        // When the form submit button is clicked...
        self.elem.addEventListener('submit', evt => {
            // Prevent the form from submitting
            evt.preventDefault();

            if(global.hasMap && global.hasMap == true) {
                // If consultation map exists, send report
                self.sendFeedbackReport();
            } else {
                // Submit the form to Catcher
                self.elem.submit();
                // Clear local storage
                localStorage.clear();
            }
        });
    }

    sendFeedbackReport() {        
        let self = this;

        var axios = require('axios');
        var FormData = require('form-data');
        
        // Append required data in acceptable format for api endpoint
        var data = new FormData();

        // Collect user data
        let first_name = JSON.parse(localStorage.getItem('08-first_name')).value.trim();
        let last_name = JSON.parse(localStorage.getItem('09-last_name')).value.trim();
        let postcode = JSON.parse(localStorage.getItem('11-postcode')).value.trim();

        // Check required fields are not blank
        if(first_name !== '' && last_name !== '' && postcode !== '') {
            
            // Append required user data
            data.append('first_name', first_name);
            data.append('last_name', last_name);
            data.append('postcode', postcode);

            // Append all other data if exists
            if(JSON.parse(localStorage.getItem('07-title')).value && JSON.parse(localStorage.getItem('07-title')).value != '') {
                data.append('title', JSON.parse(localStorage.getItem('07-title')).value.trim());
            }

            if(JSON.parse(localStorage.getItem('email')).value && JSON.parse(localStorage.getItem('email')).value != '') {
                data.append('email', JSON.parse(localStorage.getItem('email')).value.trim());
            }

            if(JSON.parse(localStorage.getItem('10-address')).value && JSON.parse(localStorage.getItem('10-address')).value != '') {
                data.append('address', JSON.parse(localStorage.getItem('10-address')).value.trim());
            }

            if(JSON.parse(localStorage.getItem('12-phone')).value && JSON.parse(localStorage.getItem('12-phone')).value != '') {
                data.append('phone', JSON.parse(localStorage.getItem('12-phone')).value.trim());
            }

            if(JSON.parse(localStorage.getItem('14-organisation')).value && JSON.parse(localStorage.getItem('14-organisation')).value != '') {
                data.append('organisation', JSON.parse(localStorage.getItem('14-organisation')).value.trim());
            }

            if(JSON.parse(localStorage.getItem('15-progress')).value && JSON.parse(localStorage.getItem('15-progress')).value != '') {
                data.append('progress', JSON.parse(localStorage.getItem('15-progress')).value.trim());
            }
    
            // Loop through sections, append question data
            global.consultation.themes.forEach((theme, i) => {
                if(localStorage.getItem('0' + i + '-question') && localStorage.getItem('0' + i + '-question').value != '') {
                    let question = JSON.parse(localStorage.getItem('0' + i + '-question')).value.trim();
                    question ? data.append(i + '-question', question) : null;
                }
            })
            
            var config = {
                method: 'post',
                url: global.mapUrl + '/api/feedback-form/1',
                headers: { 
                    'key': '7jfecPuxW37r',
                    'secret': 'asmZmd99SB6BskpC4euepz'
                },
                data: data
            };
    
            axios(config)
                .then(function (response) {
                    // Submit the form
                    self.elem.submit();
                    // Clear local storage
                    localStorage.clear();
                })
                .catch(function (error) {
                    // Send error to Bugsnag
                    Bugsnag.notify(error)
                    // Show error message to user
                    document.getElementById("form-error").innerHTML = 'Sorry, there was an error trying to send your feedback, please check your submission and try again. If the problem persists please contact us on ' + global.base.contact_email;
                });
        } else {
            // Send error to Bugsnag
            Bugsnag.notify(error)
            // Show error message to user
            document.getElementById("form-error").innerHTML = 'Please check that you have completed all required fields. If so and the problem persists, please contact us on ' + global.base.contact_email;
        }

    }

    // Convert carriage returns to line breaks for displaying textarea
    // content in the table
    nl2br(str, is_xhtml) {
        if (typeof str === 'undefined' || str === null) {
            return '';
        }
        var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
        return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
    }
}

export default FormReview;